import React from 'react';

const MessageBubble = ({ message, styles, children }) => {
  return (
    <div
      className="message-bubble-wrapper"
      style={{
        ...styles.messageBubble,
        ...(message.sent ? styles.myMessage : styles.theirMessage),
        animation: 'messageSlideIn 0.3s cubic-bezier(0.16, 1, 0.3, 1) both',
      }}
    >
      {children}
    </div>
  );
};

export default MessageBubble;